import { render, staticRenderFns } from "./RecentSelections.vue?vue&type=template&id=523da4a1&scoped=true&"
import script from "./RecentSelections.vue?vue&type=script&lang=js&"
export * from "./RecentSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523da4a1",
  null
  
)

export default component.exports